"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _propTypes = _interopRequireDefault(require("prop-types"));
const FormSelect = props => {
  const settings = props.widget.settings,
    header_font = props.mobilization.header_font,
    onChange = props.onChange,
    value = props.value,
    onSubmit = props.onSubmit;
  const mainColor = settings && settings.main_color || '#54d0f6';
  const donation_value1 = settings.donation_value1,
    donation_value2 = settings.donation_value2,
    donation_value3 = settings.donation_value3,
    donation_value4 = settings.donation_value4,
    donation_value5 = settings.donation_value5;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "donation center clearfix"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "p2 m0 white rounded-top",
    style: {
      fontFamily: header_font,
      backgroundColor: mainColor,
      fontWeight: 'bold'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "widgets.components--donation.finish-post-donation.title-component",
    defaultMessage: "OBA! Doa\xE7\xE3o Realizada :)"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "p3",
    style: {
      paddingTop: 0
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "center clearfix p2"
  }, /*#__PURE__*/_react.default.createElement("b", null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "widgets.components--donation.finish-post-donation.improve-impact-question",
    defaultMessage: "Quer aumentar seu impacto?"
  })), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "widgets.components--donation.finish-post-donation.improve-impact-solution",
    defaultMessage: "Torne essa doa\xE7\xE3o recorrente!"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "center clearfix mb2",
    style: {
      fontSize: 14,
      color: 'gray'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "widgets.components--donation.finish-post-donation.improve-impact-explanation",
    defaultMessage: "Sua contribui\xE7\xE3o ser\xE1 efetivada automaticamente uma vez ao m\xEAs, iniciando daqui h\xE1 31 dias."
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "center clearfix"
  }, /*#__PURE__*/_react.default.createElement("select", {
    className: "select mb2",
    onChange: onChange,
    value: value
  }, donation_value1 && /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "widgets.components--donation.finish-post-donation.value-list",
    defaultMessage: "R$ {value} / m\xEAs",
    values: {
      value: donation_value1
    }
  }, message => /*#__PURE__*/_react.default.createElement("option", {
    value: 1
  }, message)), donation_value2 && /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "widgets.components--donation.finish-post-donation.value-list",
    defaultMessage: "R$ {value} / m\xEAs",
    values: {
      value: donation_value2
    }
  }, message => /*#__PURE__*/_react.default.createElement("option", {
    value: 2
  }, message)), donation_value3 && /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "widgets.components--donation.finish-post-donation.value-list",
    defaultMessage: "R$ {value} / m\xEAs",
    values: {
      value: donation_value3
    }
  }, message => /*#__PURE__*/_react.default.createElement("option", {
    value: 3
  }, message)), donation_value4 && /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "widgets.components--donation.finish-post-donation.value-list",
    defaultMessage: "R$ {value} / m\xEAs",
    values: {
      value: donation_value4
    }
  }, message => /*#__PURE__*/_react.default.createElement("option", {
    value: 4
  }, message)), donation_value5 && /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "widgets.components--donation.finish-post-donation.value-list",
    defaultMessage: "R$ {value} / m\xEAs",
    values: {
      value: donation_value5
    }
  }, message => /*#__PURE__*/_react.default.createElement("option", {
    value: 5
  }, message))), /*#__PURE__*/_react.default.createElement("button", {
    id: "donate-btn",
    onClick: () => onSubmit(value),
    className: "btn col-12 p2 mb2",
    style: {
      backgroundColor: mainColor,
      color: 'white'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "widgets.components--donation.finish-post-donation.support-every-month",
    defaultMessage: "APOIAR TODO M\xCAS"
  })), /*#__PURE__*/_react.default.createElement("button", {
    id: "not-now-btn",
    onClick: () => onSubmit(),
    className: "btn col-12 p2"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "widgets.components--donation.finish-post-donation.not-now",
    defaultMessage: "AGORA N\xC3O"
  })))));
};
var _default = exports.default = FormSelect;